import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { URL } from "../../store/actions/depannageActions"
import { COLORS } from "../../utilities/Constants"

// B9 (CDC 16.10) : année en cours / suivante sans jours fériés générés —
// le tarif police (jour / nuit, fériés = N) les ignorerait. Affichée au
// dispatch (lecture `?resume=1`) et dans l'onglet Jours fériés (`annees`
// fourni par le payload déjà chargé).
export const texteJoursFeriesManquants = (annees) =>
	`Jours fériés ${annees.join(" et ")} pas encore générés : le tarif police ` +
	"ne les compte pas comme jours de nuit. À générer dans Configuration › " +
	"RH › Jours fériés."

const AlerteJoursFeries = ({ annees = null }) => {
	const token = useSelector((s) => s.navInfo.login.token)
	const [manquantes, setManquantes] = useState(annees || [])

	useEffect(() => {
		if (annees !== null) {
			setManquantes(annees)
			return
		}
		let vivant = true
		fetch(`${URL}api/jours_feries?resume=1`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then((res) => (res.ok ? res.json() : null))
			.then((json) => {
				if (vivant && json) setManquantes(json.annees_manquantes || [])
			})
			.catch(() => {})
		return () => {
			vivant = false
		}
	}, [annees, token])

	if (!manquantes.length) return null
	return (
		<div style={st.bandeau} role="alert">
			{texteJoursFeriesManquants(manquantes)}
		</div>
	)
}

const st = {
	bandeau: {
		marginTop: 16,
		padding: "10px 14px",
		borderRadius: 12,
		border: `1px solid ${COLORS.warning}`,
		background: COLORS.warningLight,
		color: COLORS.text,
		fontSize: 13,
	},
}

export default AlerteJoursFeries
